
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";

const user = namespace("user");
const common_base = namespace("common_base");
const common_app = namespace("common_app");
type stateType = "init" | "selected" | "ing" | "fail" | "result";
@Component({})
export default class DataImport extends Vue {
  @common_base.Action getImportResultFileAccessUrl;
  @common_base.Action queryImportResult;
  @common_app.Getter severLanguage;
  @common_base.Action queryImportTemplateUrl;
  @Prop({ default: "" })
  templateUrl: string;
  @Prop({ default: "" })
  actionUrl: string;
  @Prop({ default: "", type: String })
  templateCode: any;
  @Prop({ default: () => ({}), type: Object })
  importParamsData: any;
  @Prop({ type: Function })
  downloadMethod: any;
  @Prop({ default: false })
  visible: boolean;
  @user.State token;
  dayjs = dayjs;
  state: stateType = "init";
  successNum = 0;
  failNum = 0;
  diaTitle = t("other.patch-import");
  compeletTime = "";
  allData = 0;
  headers = {
    userAuthToken: "",
    userLanguage: ""
  };
  resultFileUrl = ""; //下载导入失败文件路径
  fileList = [];
  get $visible() {
    return this.visible;
  }
  get $uploadUrl() {
    return window.API_URL + this.actionUrl;
  }
  created() {
    this.headers.userAuthToken = this.token;
    this.headers.userLanguage = this.severLanguage;
  }
  submitUpload() {
    const ref: any = this.$refs.upload;
    ref.submit();
  }
  handleRemove(file: any, fileList: any) {
    console.log(file, fileList);
    this.state = "init";
  }
  handleDownloadTemplate() {
    if (typeof this.downloadMethod === "function") {
      this.downloadMethod().then(data => {
        if (data && data.templateUrl) {
          location.href = `${data.templateUrl}`;
        }
      });
    } else {
      // 更具actionUrl 截取获得templateCode参数
      this.queryImportTemplateUrl({
        templateCode: this.templateCode || this.actionUrl.slice(11)
      }).then(data => {
        if (data.data) {
          location.href = `${data.data}?now=${Date.now()}`;
        }
      });
      this.$emit("down");
    }
  }
  handlePreview(file: any) {
    console.log(file, "preview");
  }
  errorEvent() {
    this.state = "fail";
    this.fileList = [];
  }
  loadingObj: any;
  upPending() {
    this.state = "ing";
    this.loadingObj = this.$loading({
      lock: true,
      text: t("v213.importing-data-please-dont-leave-and-this-page"),
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
  }
  resultFileKey: string = "";
  upSuccess(response) {
    if (response.data) {
      // 订单导入特殊处理异步轮询
      if (this.actionUrl !== "/filecloud/importOrder" || response.data.finish) {
        this.loadingObj.close();
        this.state = "result";
        this.diaTitle = t("other.patch-import-result") as string;
        const { failedLines, resultFilePath, totalLines, resultFileKey } = response.data;
        this.successNum = totalLines - failedLines;
        this.allData = totalLines;
        this.failNum = failedLines;
        this.compeletTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
        this.resultFileUrl = resultFilePath;
        this.resultFileKey = resultFileKey;
        this.$emit("upLoadSuccess", response.data);
      } else {
        this.loopQueryImportResult(response.data);
      }
    } else {
      this.fileList = [];
      this.loadingObj.close();
      // 导入失败
      this.state = "fail";
    }
  }
  loopQueryImportResult(result) {
    this.queryImportResult({
      importResultCode: result.importResultCode
    }).then(data => {
      if (data.data.finish) {
        this.upSuccess(data);
      } else {
        setTimeout(this.loopQueryImportResult, 3000, result);
      }
    });
  }
  changeUpload(file: any, fileList: any) {
    if (fileList.length > 0 && file.status == "ready") {
      this.state = "selected";
    }
  }
  handleClose() {
    this.$emit("update:visible", false);
  }
  cancelOrContinue() {
    if (this.state !== "result") {
      // 关闭
      this.fileList = [];
      this.state = "init";
      this.handleClose();
    } else {
      // 继续导入
      this.fileList = [];
      this.state = "init";
      this.resultFileKey = "";
      this.diaTitle = t("other.patch-import");
    }
  }
  handleDownloadFailData() {
    if (this.resultFileKey) {
      this.getImportResultFileAccessUrl({
        resultFileKey: this.resultFileKey
      }).then(data => {
        window.open(data.data);
      });
    }
  }
  beforeUpload() {
    console.log("上传之前");
  }
}
